import create, { SetState } from "zustand";

import { SurveyModal, SurveyStore, SurveysTab } from "./model";

export const useSurveyStore = create<SurveyStore>((set: SetState<SurveyStore>) => ({
	surveysPageTab: {
		key: "all-surveys",
		title: "All Surveys",
	},
	surveyName: "",
	modal: null,
	surveyLink: "",
	surveyId: "",
	setters: {
		setSurveysPageTab: (page: SurveysTab) => set({ surveysPageTab: page }),
		setModal: (modal: SurveyModal | null) => set({ modal }),
		setSurveyLink: (link: string) => set({ surveyLink: link }),
		setSurveyId: (id: string) => set({ surveyId: id }),
		setSurveyName: (name: string) => set({ surveyName: name }),
	},
	actions: {
		resetStore: () => {
			set({ modal: null });
			set({
				surveyName: "",
				surveyLink: "",
				surveyId: "",
			});
		},
	},
}));

export const useSetters = () => useSurveyStore((state) => state.setters);
export const useActions = () => useSurveyStore((state) => state.actions);

export const useModal = () => useSurveyStore((state) => state.modal);
export const useSurveyName = () => useSurveyStore((state) => state.surveyName);
export const useSurveyLink = () => useSurveyStore((state) => state.surveyLink);
export const useSurveyId = () => useSurveyStore((state) => state.surveyId);
export const useSurveysPageTab = () => useSurveyStore((state) => state.surveysPageTab);
